import { SadHouse } from 'svg';

export default function Maintenance() {
  return (
    <div
      className="flex flex-col h-screen items-center justify-center gap-y-2 bg-grayMuted"
      id="maintenance-page"
    >
      <SadHouse />
      <h2 className="mb-5 text-center">
        The dashboard is not available right now
      </h2>
      <p className="text-center">{"We're working to bring it back online."}</p>
      <p className="text-center">Please check again later.</p>
    </div>
  );
}
